var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
    stroke: "#FF5959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99995 4C8.44178 4 8.79995 4.35817 8.79995 4.8V8C8.79995 8.44183 8.44178 8.8 7.99995 8.8C7.55812 8.8 7.19995 8.44183 7.19995 8V4.8C7.19995 4.35817 7.55812 4 7.99995 4Z",
    fill: "#FF5959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19995 11.1999C7.19995 10.7581 7.55812 10.3999 7.99995 10.3999H8.00795C8.44978 10.3999 8.80795 10.7581 8.80795 11.1999C8.80795 11.6417 8.44978 11.9999 8.00795 11.9999H7.99995C7.55812 11.9999 7.19995 11.6417 7.19995 11.1999Z",
    fill: "#FF5959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputErrorIcon);
export default __webpack_public_path__ + "static/media/input-error-icon.b11aa6775384a09e2fb91fb1da2eee92.svg";
export { ForwardRef as ReactComponent };